angular
    .module("accordionUploadDocumentsInstantTemp.components", [])
    .component("accordionUploadDocumentsInstantTemp", {
        templateUrl: "ng/components/accordionUploadDocumentsInstantTemp/accordionUploadDocumentsInstantTemp.view.html",
        bindings: {
            userDaCensire: "=",
            enabledSave: "&",
            appIlTransaction: "<",
            isIntegration: "<",
            goBackModal: "&",
            isDigital: '<',
            financialModel: '<',
            snapshot: '<',
            portalRunned: '<',
            isPostVendita: '<',
            listaNazioni: '<',
            elencoListaEntiRilascio: '<'
        },
        controllerAs: "uploadDocumentsInstantCtrl",
        controller: function accordionUploadDocuments(
            $configService,
            $rootScope,
            $timeout,
            $typeDomainService,
            Documento,
            $modalService,
            $scope,
            validationService,
            Pf,
            $download,
            $userService,
            HttpService,
            EnteRilascio,
            $portalService,
            $istatService,
            Stato,
            $uniService
        ) {
            var self = this;
            var getStati = function (listaNazioni) {
                if (listaNazioni && listaNazioni.length) {
                    self.listaNomiStatiNascita = listaNazioni;

                    self.listaNomiStatiNascita = self.listaNomiStatiNascita.filter(
                        function (elem) {
                            return elem.name != "ITALIA";
                        }
                    );
                    self.listaNomiStatiResidenza = self.listaNomiStatiNascita.filter(
                        function (element) {
                            return !element.deleted
                        }
                    )

                    self.listStatiRilascio = self.listaNomiStatiNascita.map(function (element) {
                        return element.name;
                    })

                } else {
                    $istatService.getNazioni()
                        .then(function (response) {
                            self.listaNomiStatiNascita = response.domainList;

                            self.listaNomiStatiNascita = self.listaNomiStatiNascita.filter(
                                function (elem) {
                                    return elem.name != "ITALIA";
                                }
                            );
                            self.listaNomiStatiResidenza = self.listaNomiStatiNascita.filter(
                                function (element) {
                                    return !element.deleted
                                }
                            )

                            self.listStatiRilascio = self.listaNomiStatiNascita.map(function (element) {
                                return element.name;
                            })
                        })

                }

            };

            var getTypeStreet = function () {
                $uniService.streetype()
                    .then(function (response) {
                        self.dropdown.typeStreet = response.domainList
                    })

            }



            self.$onInit = (function () {
                getTypeStreet();
                self.refreshDocRegex = true;
                self.testDati = {
                    value: true,
                    error: ""
                }
                self.cfAziendaleIsRequired = false;
                self.enteRilascioModel = "";
                self.disabledForUploadingInProgress = false;
                self.disabeldUploadFront = false;
                self.disabeldUploadBack = false;
                self.disabeldUploadCfFront = false;
                self.disabeldUploadCfBack = false;
                self.disabledFirmatarioTitolare = false;
                self.ilTransaction = 0;
                self.dealerUser = {};
                self.showLoader = false;
                self.base64 = null;
                self.link = "";
                self.progress = 0;
                self.frontBase64 = "";
                self.backBase64 = "";
                self.disabledInputCf = false;
                self.disabledInputDoc = false;
                self.mapComuni = $rootScope.comuniMap;
                self.comuniNsilSoppressi = $rootScope.mapComuniSoppressi;
                self.currentCodeTypeNameIndex = 0;
                self.listaProvince = [];
                self.listaProvinceRilascio = [];
                self.listaNomeComuniRilascio = [];
                self.listaNomeComuniNascita = [];
                self.listaNomiStatiNascita = [];
                self.listaNomiStatiResidenza = [];
                self.listaNomeComuniResidenza = [];
                self.listaCap = [];
                self.yesterday = moment().add(-1, "days").format("DD/MM/YYYY");
                self.today = moment().format("DD/MM/YYYY");
                self.tomorrow = moment()
                    .add(1, "days")
                    .format("DD/MM/YYYY");
                self.userDaCensire = self.userDaCensire | {};
                self.documentUpload = [];
                self.enabledModifyDocumentDate = false;
                self.currentSlide = 0;
                self.userDaCensire = {
                    titolare: {
                        selected: false
                    },
                    firmatario: {
                        selected: false
                    }
                };
                Object.assign(self.userDaCensire, {
                    titolare: {
                        selected: false
                    },
                    firmatario: {
                        selected: false
                    }
                });

                self.dropdown = {
                    ruolo: [],
                    stati: [],
                    comune: [],
                    statiEsteri: [],
                    entiRilascio: [],
                    tipiDocumento: [],
                    tipoGarante: [],
                    typeStreet: []
                };
                self.validationObj = {
                    documentDate: {
                        disabledDays: [0],
                        disabledDates: [
                            "01-01",
                            "06-01",
                            "25-04",
                            "01-05",
                            "02-06",
                            "15-08",
                            "01-11",
                            "08-12",
                            "25-12",
                            "26-12"
                        ]
                    },
                    regex: {
                        documentNumber: /.+/
                    }
                };
                self.listaProvince = self.mapComuni
                    .map(function (comune) {
                        return comune.sigla;
                    })
                    .filter(function (siglaComune) {
                        return siglaComune != "";
                    })
                    .sort()
                    .reduce(function (result, nextItem) {
                        return result.includes(nextItem) ? result : result.concat(nextItem);
                    }, []);
                self.listaProvince.push("EE");
                self.listaProvinceRilascio = self.listaProvince;
                self.listaProvinceResidenza = self.listaProvince.filter(x => x != "EE");

                self.creaComuniRilascio = function (provincia, check) {
                    self.listaNomeComuniRilascio = self.mapComuni
                        .filter(function (comune) {
                            return comune.sigla == provincia;
                        });
                    if (!check) {
                        self.userDaCensire.documento.luogoEsteso = {};
                        self.userDaCensire.documento.luogo = null;
                    }
                    if ((provincia == 'BZ' || provincia == 'TN') && self.userDaCensire.documento.tipo == 'CAI') {
                        self.regExpDocumento = 'CAIBZTN';
                    } else {
                        self.regExpDocumento = self.userDaCensire.documento.tipo
                    }
                    self.refreshDocRegex = false;
                    $timeout(function () {
                        self.refreshDocRegex = true;
                    }, 50)
                };

                self.creaComuniNascita = function (provincia, check) {
                    self.listaNomeComuniNascita = self.mapComuni
                        .filter(function (comune) {
                            return comune.sigla == provincia;
                        });
                    if (!check) {
                        self.userDaCensire.datiNascita.luogoEsteso = "";
                    }
                    self.verifyDate();
                };

                self.creaComuniResidenza = function (provincia, check) {
                    if (!check) {
                        self.userDaCensire.residenza.cap = "";
                        self.userDaCensire.residenza.indirizzo = "";
                        self.userDaCensire.residenza.numeroCivico = "";
                        self.userDaCensire.residenza.comune = "";
                        self.userDaCensire.residenza.luogoEsteso = {};
                        if (provincia != "EE") {
                            self.userDaCensire.residenza.stato = Stato.build();
                        } else {
                            self.userDaCensire.residenza.stato = "";
                        }
                        self.userDaCensire.residenza.idNsil = null;
                    }

                    if (provincia == "EE" || provincia == "SE") {
                        self.isForeign = true;
                        return;
                    } else {
                        self.isForeign = false;
                    }
                    self.listaNomeComuniResidenza = self.mapComuni
                        .filter(function (comune) {
                            return comune.sigla == provincia;
                        });


                };

                self.creaCap = function (comune, chiamataDalRest) {

                    if (!chiamataDalRest) {
                        self.userDaCensire.residenza.cap = "";
                        self.userDaCensire.residenza.idNsil = null;
                    }

                    if (comune.cap && comune.cap.length > 0) {
                        self.listaCap = comune.cap;

                    } else {
                        if (self.listaNomeComuniResidenza.length > 0 && comune.nome) {
                            var tempComune = self.listaNomeComuniResidenza
                                .find(function (element) {
                                    return element.nome.toUpperCase() == comune.nome.toUpperCase();
                                });

                            self.listaCap = tempComune && tempComune.cap;
                        }



                    }

                    self.userDaCensire.residenza.comune = comune && comune.nome;

                    //RN:12378303
                    self.userDaCensire.firmatario.spid = 'N';    

                };
                //getRuoli();
                $typeDomainService
                    .getRoles()
                    .then(function (response) {
                        self.dropdown.ruolo = response;
                    })
                    .catch(function (err) {
                        $rootScope.$broadcast("addAlert", {
                            text: "ERROR_NEXT"
                        });
                    });
                $typeDomainService
                    .getDomainSet("GARANTE", "ROLE")
                    .then(function (response) {
                        self.dropdown.tipoGarante = response.domainList && response.domainList
                            .map(function (element) {
                                return element.value
                            });
                    });
                $timeout(function () {
                    getStati(self.listaNazioni);
                    if ($portalService.isAra()) {
                        self.unlockDocumentFields = true;
                    } else {
                        self.unlockDocumentFields = false;
                    }
                    self.userDaCensire = Pf.build(self.userDaCensire);
                    self.enteRilascioModel = self.userDaCensire.documento.enteRilascio;
                    if (self.userDaCensire.documento.imgDocumentoCfFront) {
                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoCfFront,
                            type: "imgCf",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);

                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoCfBack,
                            type: "imgCf",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);

                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoFront,
                            type: "imgDocument",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);

                        var tmp = {
                            name: self.userDaCensire.documento.imgDocumentoBack,
                            type: "imgDocument",
                            waitFromLink: true,
                            downloadLink: ""
                        };
                        self.documentUpload.push(tmp);
                        self.userDaCensire.isOk = false;

                        self.indexDocument = 0;
                        self.disabeldUploadCfFront = true;
                        self.disabeldUploadCfBack = true;
                        self.unlockDocumentFields = true;
                    }
                    if (!self.userDaCensire.documento.imgDocumentoFront && $portalService.isAru() && !self.userDaCensire.addToAdv) {

                        self.userDaCensire.documento.tipo = "";

                    } else {
                        self.disabeldUploadFront = true;
                        self.disabeldUploadBack = true;
                    }
                    if (!self.userDaCensire.documento.idImgDocumentoFrontOther && !self.userDaCensire.documento.idImgDocumentoBackOther) {
                        self.userDaCensire.ulterioreDocumento.tipo = ""
                    }
                    if (self.userDaCensire.documento.tipo) {
                        self.enabledModifyDocumentDate = true;
                        self.regExpDocumento = self.userDaCensire.documento.tipo;
                        if ((self.userDaCensire.documento.provincia == 'BZ' || self.userDaCensire.documento.provincia == 'TN') && self.userDaCensire.documento.tipo == 'CAI') {
                            self.regExpDocumento = 'CAIBZTN';
                        }
                        if (self.userDaCensire.documento.tipo == 'CAE') {
                            self.userDaCensire.documento.provincia = 'EE';
                            self.disabledProvRilascioEstera = true;
                        } else {
                            self.disabledProvRilascioEstera = false;
                        }

                        if (self.userDaCensire.documento.tipo == 'UCO') {
                            self.ucoDocumentSelected = true;
                            self.userDaCensire.documento.provincia = 'RM';
                            var roma = self.mapComuni
                                .find(function (comune) {
                                    return comune.nome.toLowerCase() == 'roma';
                                });
                            self.userDaCensire.documento.luogoEsteso = roma;
                            self.setLuogo('documento', roma)
                        } else {
                            self.ucoDocumentSelected = false;
                        }
                    }
                    self.disabledUploadDocument();
                    //initCarousel();
                    dealerUser();

                    self.ilTransaction = self.isDigital ? 0 : self.appIlTransaction.id;
                    self.listaNomeRilascio = getEntiRilascio(
                        self.userDaCensire.documento.tipo
                    );

                    if (self.userDaCensire.residenza.luogoEsteso.nome == "") {

                        self.userDaCensire.residenza.luogoEsteso = "";

                    }
                    if (self.userDaCensire.datiNascita.luogoEsteso.nome == "") {

                        self.userDaCensire.datiNascita.luogoEsteso = "";

                    }
                    if (self.userDaCensire.documento.luogoEsteso.nome == "") {

                        self.userDaCensire.documento.luogoEsteso = "";
                    }
                    if (self.userDaCensire.residenza.provincia && self.userDaCensire.residenza.provincia != 'SE' && self.userDaCensire.residenza.provincia != 'EE') {
                        self.userDaCensire.residenza.luogoEsteso = {
                            nome: self.userDaCensire.residenza.comune

                        }
                        self.isForeign = false;
                        self.creaComuniResidenza(self.userDaCensire.residenza.provincia, true);
                    } else {

                        if (self.userDaCensire.residenza.comune) {
                            self.userDaCensire.residenza.stato = self.listaNomiStatiResidenza.find(function (element) {
                                return element.name.toUpperCase() == self.userDaCensire.residenza.comune.toUpperCase()
                            })
                            self.userDaCensire.residenza.statoEsteso = self.listaNomiStatiResidenza.find(function (element) {
                                return element.name.toUpperCase() == self.userDaCensire.residenza.comune.toUpperCase()
                            })
                            self.userDaCensire.residenza.provincia = 'EE';
                            if (!!self.userDaCensire.residenza && !!self.userDaCensire.residenza.localita) {
                                self.userDaCensire.residenza.comune = self.userDaCensire.residenza.localita;
                                self.userDaCensire.residenza.luogoEsteso.nome = self.userDaCensire.residenza.localita;
                            }

                        } else if (self.userDaCensire.residenza.luogoEsteso && self.userDaCensire.residenza.luogoEsteso.nome) {
                            self.userDaCensire.residenza.stato = self.listaNomiStatiResidenza.find(function (element) {
                                return element.name.toUpperCase() == self.userDaCensire.residenza.luogoEsteso.nome.toUpperCase()
                            })
                            self.userDaCensire.residenza.statoEsteso = self.listaNomiStatiResidenza.find(function (element) {
                                return element.name.toUpperCase() == self.userDaCensire.residenza.luogoEsteso.nome.toUpperCase()
                            })
                            self.userDaCensire.residenza.provincia = 'EE';
                            if (!!self.userDaCensire.residenza && !!self.userDaCensire.residenza.localita) {
                                self.userDaCensire.residenza.comune = self.userDaCensire.residenza.localita;
                                self.userDaCensire.residenza.luogoEsteso.nome = self.userDaCensire.residenza.localita;
                            }

                        }
                        self.isForeign = true;
                    }
                    if (self.userDaCensire.datiNascita.provincia) {
                        self.creaComuniNascita(self.userDaCensire.datiNascita.provincia, true);
                    }
                    if (self.userDaCensire.documento.provincia) {
                        self.creaComuniRilascio(self.userDaCensire.documento.provincia, true);
                    }
                    if (self.isDigital) {
                        self.disabledFirmatarioIsCustomer = false;
                    }
                    if (self.userDaCensire.residenza.luogoEsteso.nome && self.userDaCensire.residenza.provincia != 'SE' && self.userDaCensire.residenza.provincia != 'EE') {
                        self.creaCap(self.userDaCensire.residenza.luogoEsteso, true);
                    }
                    if (getWizardMap(self.financialModel.viewIndex) == "M17") {
                        self.isM17Map = true;

                    } else {
                        self.isM17Map = false;
                    }
                    if (getWizardMap(self.financialModel.viewIndex) == "M15") {
                        self.isM15Map = true;

                    } else {
                        self.isM15Map = false;
                    }
                    if (self.financialModel.leasingData && self.financialModel.leasingData.preventivo.firmaDigitale && !self.financialModel.leasingData.preventivo.firmaDigitaleEsterna) {
                        self.enablePhone = true;
                    } else {
                        self.enablePhone = false;
                    }
                    if (!self.userDaCensire.firmatario.selected && self.userDaCensire.titolare.selected && self.financialModel.leasingData.preventivo.smallTicket && !self.isM17Map) {
                        self.isSmallTicketDocNotRequired = true;
                    } else {
                        self.isSmallTicketDocNotRequired = false;
                    }
                    self.verifyDate();
                }, 1);

                self.typePerson = $configService.getUser().type
                if (self.typePerson === 'ASSOCIATE_PERSON' || self.typePerson === 'SIGNER') {
                    self.disabeldPep = true;
                    self.disabledFirmatarioTitolare = true;
                    self.userDaCensire.titolare = {
                        pep: {
                            selected: "N"
                        }
                    }
                } else {
                    self.disabledFirmatarioIsCustomer = true;
                }

                self.linkPep = '/uni/download/service-infos/' +
                    encodeURIComponent('GLOSSARIO') + '/'


            })(
                (self.loadingStatus = {
                    uploading: false,
                    loadingDataFromCerved: false,
                    savedDataFromCerved: false,
                    loading: false,
                    loadingAddressesList: false,
                    loadingPfList: false,
                    insertingContract: false
                })
            );

            self.downloadInfoPep = () => {

                $download.getGenericDownload(self.linkPep)
                    .then(function (response) {
                        console.log(response);
                    })
            }




            self.check = function (el) {
                el.selected = !el.selected;
                if (!self.userDaCensire.firmatario.selected) {
                    self.userDaCensire.firmatario.ruolo = "";
                    self.userDaCensire.email = "";
                } else if (!self.userDaCensire.titolare.selected) {
                    self.userDaCensire.titolare.pep = "N";
                }

                if (!self.userDaCensire.firmatario.selected && self.userDaCensire.titolare.selected && self.financialModel.leasingData.preventivo.smallTicket && !self.isM17Map) {
                    self.isSmallTicketDocNotRequired = true;
                } else {
                    self.isSmallTicketDocNotRequired = false;
                }



            };


            self.enabledTrashRemovePdf = function () {
                return self.documentUpload.some(function (element) {
                    return element.selected === true;
                });
            };

            self.leastDocumentUpload = function () {
                var ritorno = false;

                ritorno = self.documentUpload.some(function (element) {
                    return element.type === "imgDocument" && element.name;
                });
                return ritorno;
            };

            self.leastDocumentCfUpload = function () {
                var ritorno = false;
                ritorno = self.documentUpload.some(function (element) {
                    return element.type === "imgCf";
                });
                return ritorno;
            };

            self.enteRilascioSelezionato = function (ente) {
                if (self.userDaCensire.documento.tipo === "PAT") {
                    if (ente === "MINISTERO") {
                        self.regExpDocumento = "UCO";
                    } else if (ente === "DIPARTIM. TRASPORTI TERRESTI") {
                        self.regExpDocumento = "PAM";
                    } else if (ente === "PREFETTURA") {
                        self.regExpDocumento = "PAT";
                    }
                }
                console.log(ente);
                self.userDaCensire.documento.enteRilascio = {
                    name: ente
                };
            };

            self.listaEntiRilascio = function (preserveData) {
                if (preserveData) {
                    return;
                }
                /*                 self.userDaCensire.documento.imgDocumentoFront = "";
                                self.userDaCensire.documento.imgDocumentoBack = ""; */

                self.enabledModifyDocumentDate = true;
                self.documentUpload = self.documentUpload.filter(function (element) {
                    return element.type != "imgDocument";
                });
                self.disabledUploadDocument();
            };

            self.savePfData = function (pf) {
                console.log(pf);
                pf.isOk = true;
                self.modalShow = false;
                if (pf.documento.provincia != 'EE' && pf.documento.provincia != 'SE') {
                    pf.documento.luogo = pf.documento.luogoEsteso.nome;
                }
                pf.datiNascita.comune = pf.datiNascita.luogoEsteso.nome;
                pf.residenza.comune = pf.residenza.luogoEsteso.nome;
                pf.documento.enteRilascio = EnteRilascio.build(self.enteRilascioModel);
                pf = Pf.build(pf);
                self.enabledSave({
                    Pf: pf
                });
            };
            self.undoDocumentChanges = function (pf) {
                if (self.isIntegration === true || self.validateForm()) {
                    pf.isOk = true;
                    $modalService.closeModal("censusPerson");
                    $("#footerInstant").css("z-index", "2");
                    $('.financial-leasing__footer').css("z-index", "2");
                    jQuery('.mCSB_scrollTools').css("z-index", "2");
                } else {
                    pf.isOk = false;
                    $modalService.closeModal("censusPerson");
                    $("#footerInstant").css("z-index", "2");
                    $('.financial-leasing__footer').css("z-index", "2");
                    jQuery('.mCSB_scrollTools').css("z-index", "2");
                    self.enabledSave({
                        Pf: pf
                    });
                }
                self.goBackModal && self.goBackModal();

            };

            self.getEndDate = function (dataRilascio) {
                if (dataRilascio) {
                    var tipoDocumento = self.userDaCensire.documento.tipo;
                    var dataNascita = self.userDaCensire.datiNascita.data;
                    var dataRilascio = moment(dataRilascio, "DD/MM/YYYY");
                    var startYear = moment(dataRilascio).format("YYYY");
                    var startDay = moment(dataRilascio).format("DD");
                    var startMonth = moment(dataRilascio).format("MM");

                    var endDate = moment(dataRilascio)
                        .add(10, "years")
                        .format("DD/MM/YYYY");

                    if (
                        tipoDocumento === propMap["DOC_TYPE_CAI"] ||
                        tipoDocumento === propMap["DOC_TYPE_NCE"] ||
                        tipoDocumento === propMap["DOC_TYPE_CIE"] ||
                        tipoDocumento === propMap["DOC_TYPE_CAE"] ||
                        tipoDocumento === propMap["DOC_TYPE_PAT"] ||
                        tipoDocumento === propMap['DOC_TYPE_PAM'] ||
                        tipoDocumento === propMap['DOC_TYPE_UCO'] ||
                        self.isM17Map
                    ) {
                        var dataNascita = moment(dataNascita, "DD/MM/YYYY");
                        var birthYear = moment(dataNascita).format("YYYY");
                        var birthDay = moment(dataNascita).format("DD");
                        var birthMonth = moment(dataNascita).format("MM");

                        if (birthMonth == '02' && birthDay == '29') {
                            birthMonth = '03';
                            birthDay = '01';
                        }

                        var futureBirthDay = moment(
                            birthDay + "/" + birthMonth + "/" + startYear,
                            "DD/MM/YYYY"
                        )
                            .add(10, "years")
                            .format("DD/MM/YYYY");
                        //console.log("Compleanno Futuro: " + futureBirthDay);

                        var daysDiff = moment
                            .duration(
                                moment(endDate, "DD/MM/YYYY").diff(
                                    moment(futureBirthDay, "DD/MM/YYYY")
                                )
                            )
                            .asDays();

                        var expiryDate;
                        if (daysDiff <= 0) {
                            expiryDate = moment(futureBirthDay, "DD/MM/YYYY").format(
                                "DD/MM/YYYY"
                            );
                        } else {
                            expiryDate = moment(
                                birthDay + "/" + birthMonth + "/" + startYear,
                                "DD/MM/YYYY"
                            )
                                .add(11, "years")
                                .format("DD/MM/YYYY");
                        }

                        while (
                            (moment(expiryDate, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY")) <= 0) &&
                            ((tipoDocumento === propMap["DOC_TYPE_CAI"]) || (tipoDocumento === propMap["DOC_TYPE_PAT"]) || (tipoDocumento === propMap['DOC_TYPE_PAM']))) {
                            expiryDate = moment(
                                expiryDate,
                                "DD/MM/YYYY"
                            )
                                .add(10, "years")
                                .format("DD/MM/YYYY");
                        }

                        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
                        expiryDate = moment(expiryDate, "DD/MM/YYYY")
                            .add(2, "years")
                            .add(3, "months")
                            .format("DD/MM/YYYY");
                        //fine campo aggiunto per emergenza COVID19

                        if ($scope.pfForm && $scope.pfForm.dataScadenza && moment.duration(moment(self.userDaCensire.documento.dataScadenza, "DD/MM/YYYY").diff(moment(expiryDate, "DD/MM/YYYY"))).asDays() > 0) {
                            $scope.pfForm.dataScadenza.$valid = false;
                        }
                        if ($scope.pfForm && $scope.pfForm.dataScadenza && moment.duration(moment(self.userDaCensire.documento.dataScadenza, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY"))).asDays() < 2) {
                            $scope.pfForm.dataScadenza.$valid = false;
                            $scope.pfForm.dataScadenza.$setValidity("dataScadenza", false);
                        } else {
                            $scope.pfForm && $scope.pfForm.dataScadenza && $scope.pfForm.dataScadenza.$setValidity("dataScadenza", true);
                        }
                        return expiryDate;
                    } else {
                        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
                        endDate = moment(endDate, "DD/MM/YYYY")
                            .add(2, "years")
                            .add(3, "months")
                            .format("DD/MM/YYYY");
                        //fine campo aggiunto per emergenza COVID19
                        if (
                            moment
                                .duration(
                                    moment(
                                        self.userDaCensire.documento.dataScadenza,
                                        "DD/MM/YYYY"
                                    ).diff(moment(endDate, "DD/MM/YYYY"))
                                )
                                .asDays() > 0
                        ) {
                            $scope.pfForm.dataScadenza.$valid = false;
                        }
                        return endDate;
                    }
                } else {
                    return moment(self.today, "DD/MM/YYYY")
                        .add(10, "years")
                        .format("DD/MM/YYYY");
                }

            };

            self.validateForm = function () {
                showMissingData();
                self.allDocumentUploaded = checkFilesUpload();
                var check = self.userDaCensire.firmatario.selected;
                if ($portalService.isAra() || (self.financialModel.leasingData.preventivo.smallTicket && !check)) {

                    self.userDaCensire.documentiCaricati = true;
                    self.allDocumentUploaded = true;

                }
                if (self.userDaCensire.residenza.provincia != "EE") {
                    if (check) {
                        if (self.userDaCensire.garante.selected) {

                            return $scope.pfForm.$valid &&
                                self.userDaCensire.firmatario.ruolo &&
                                self.userDaCensire.residenza.cap &&
                                self.userDaCensire.residenza.luogoEsteso.nome &&
                                self.allDocumentUploaded &&
                                !!self.userDaCensire.documento.tipo &&
                                self.testDati.value &&
                                (self.userDaCensire.titolare.pep != 'Y' || self.isDigital) &&
                                (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)

                        } else {
                            return $scope.pfForm.$valid &&
                                self.userDaCensire.firmatario.ruolo &&
                                self.userDaCensire.residenza.cap &&
                                self.userDaCensire.residenza.luogoEsteso.nome &&
                                self.allDocumentUploaded &&
                                !!self.userDaCensire.documento.tipo &&
                                self.testDati.value &&
                                (self.userDaCensire.titolare.pep != 'Y' || self.isDigital) &&
                                (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)
                        }

                    } else if (!check && !self.userDaCensire.garante.selected) {
                        return $scope.pfForm.$valid &&
                            self.userDaCensire.residenza.cap &&
                            self.userDaCensire.residenza.luogoEsteso.nome &&
                            self.allDocumentUploaded &&
                            (!!self.userDaCensire.documento.tipo || (self.financialModel.leasingData.preventivo.smallTicket && !self.isM17Map)) &&
                            self.testDati.value &&
                            (self.userDaCensire.titolare.pep != 'Y' || self.isDigital) &&
                            (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)

                    } else {
                        return $scope.pfForm.$valid &&
                            self.userDaCensire.residenza.cap &&
                            self.userDaCensire.residenza.luogoEsteso.nome &&
                            self.allDocumentUploaded &&
                            (!!self.userDaCensire.documento.tipo || (self.financialModel.leasingData.preventivo.smallTicket && !self.isM17Map)) &&
                            self.testDati.value &&
                            (self.userDaCensire.titolare.pep != 'Y' || self.isDigital)

                    }
                } else {
                    if (check) {
                        return $scope.pfForm.$valid &&
                            self.userDaCensire.firmatario.ruolo &&
                            self.allDocumentUploaded &&
                            self.userDaCensire.residenza.stato &&
                            !!self.userDaCensire.documento.tipo &&
                            self.testDati.value &&
                            (self.userDaCensire.titolare.pep != 'Y' || self.isDigital) &&
                            (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)

                    } else if (!check && !self.userDaCensire.garante.selected) {
                        return $scope.pfForm.$valid &&
                            self.allDocumentUploaded &&
                            self.userDaCensire.residenza.stato &&
                            (!!self.userDaCensire.documento.tipo || (self.financialModel.leasingData.preventivo.smallTicket && !self.isM17Map)) &&
                            self.testDati.value &&
                            (self.userDaCensire.titolare.pep != 'Y' || self.isDigital) &&
                            (self.userDaCensire.titolare.selected || self.userDaCensire.firmatario.selected)

                    } else {
                        return $scope.pfForm.$valid &&
                            self.userDaCensire.residenza.cap &&
                            self.userDaCensire.residenza.luogoEsteso.nome &&
                            self.allDocumentUploaded &&
                            (!!self.userDaCensire.documento.tipo || (self.financialModel.leasingData.preventivo.smallTicket && !self.isM17Map)) &&
                            self.testDati.value

                    }
                }

            };

            self.getTodaysDate = function () {
                return moment().format("DD/MM/YYYY");
            };
            self.getTomorrowDate = function () {
                return moment().add(1, "days").format("DD/MM/YYYY");
            };


            self.verifyDate = function () {
                self.testDati.value = true;
                var codCat;

                if (self.userDaCensire && self.userDaCensire.datiNascita && (self.userDaCensire.datiNascita.provincia == 'EE' || self.userDaCensire.datiNascita.provincia == 'SE') && self.userDaCensire.datiNascita.stato.name) {
                    codCat = self.userDaCensire.datiNascita.stato.value;
                } else if (self.userDaCensire && self.userDaCensire.datiNascita &&
                    self.userDaCensire.datiNascita.luogoEsteso &&
                    self.userDaCensire.datiNascita.luogoEsteso.nome) {
                    var comuniCompleti = self.mapComuni.concat(self.comuniNsilSoppressi);
                    var tempCodCat = comuniCompleti
                        .filter(function (element) {
                            return element.nome.toUpperCase() == self.userDaCensire.datiNascita.luogoEsteso.nome.toUpperCase()
                        })[0].codiceCatastale;
                    codCat = self.userDaCensire.datiNascita.luogoEsteso.codiceCatastale ? self.userDaCensire.datiNascita.luogoEsteso.codiceCatastale : tempCodCat;
                }
                if (!codCat) {
                    self.testDati.value = false;
                    return;
                }

                self.testDati = validationService.checkCfWithFieds(
                    self.userDaCensire.cf,
                    self.userDaCensire.nome,
                    self.userDaCensire.cognome,
                    self.userDaCensire.datiNascita.data,
                    self.userDaCensire.sesso,
                    codCat
                );

                if (!self.testDati.value) {
                    if (typeof $scope.pfForm.userCf != "undefined") {
                        $scope.pfForm.userCf.$setValidity("userCf", false);
                    }
                } else {
                    if (typeof $scope.pfForm.userCf != "undefined") {
                        $scope.pfForm.userCf.$setValidity("userCf", true);
                    }
                }

            };

            self.disabledUploadDocument = function () {
                if (self.uploadDocumenti === "imgCf") {
                    self.uploadCfCompleted = false;
                } else {
                    self.uploadDocCompleted = false;
                    self.frontBase64 = "";
                    self.backBase64 = "";
                }
                self.disabledUploadCf = self.documentUpload.some(function (elem) {
                    return elem.type === "imgCf";
                });

                var temp = 0;

                self.documentUpload.forEach(function (elem) {
                    if (elem.type === "imgDocument") {
                        temp++;
                    }

                    if (temp >= 2) {
                        self.disabledUploadDocIdent = true;
                    } else {
                        self.disabledUploadDocIdent = false;
                    }
                });
            };

            var dealerUser = function () {
                if ($portalService.isAru()) {

                    $userService.getDealerUser()
                        .then(function (dealer) {
                            if (dealer) {
                                self.dealerUser = dealer;
                            }
                        });
                }
            }


            self.$onDestroy = function () {
                clearInterval(self.intervalOfRepeatListenMobileCapture);

                $rootScope.$broadcast("pageLoader", {
                    action: "CLOSE"
                });
            }


            /* Parte da eliminare */

            self.getFromDomain = function (table, value, list, delay, cb) {
                $timeout(function () {
                    HttpService.send('/uni/typedomain/getDomainSet', {
                        table: table,
                        column: value
                    }, false)
                        .then(function (response) {
                            if (list) {
                                self.dropdown[list] = response.domainList;
                            }

                            if (cb) {
                                cb(response);
                            }
                        });
                }, delay);
            }


            self.getFromDomain('RI_DROPDOWN_DOMAINS', 'DOCUMENT_TYPE', 'tipiDocumento', 20, function () {

                for (i = 0; i < self.dropdown.tipiDocumento.length; i++) {
                    if (self.dropdown.tipiDocumento[i].value == "CAE") {
                        self.dropdown.tipiDocumento[i].order = 40;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "CAI") {
                        self.dropdown.tipiDocumento[i].order = 10;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "CIE") {
                        self.dropdown.tipiDocumento[i].order = 20;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "NCE") {
                        self.dropdown.tipiDocumento[i].order = 30;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "PAM") {
                        self.dropdown.tipiDocumento[i].order = 50;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "PAS") {
                        self.dropdown.tipiDocumento[i].order = 80;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "PAT") {
                        self.dropdown.tipiDocumento[i].order = 60;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "UCO") {
                        self.dropdown.tipiDocumento[i].order = 70;
                    }

                    self.dropdown.tipiDocumento = self.dropdown.tipiDocumento
                        .filter(function (element) {
                            return element.value != "CAE"
                        })

                }


            });

            self.setDocNumRegex = function (tipoDocumento, fromUploadFinish) {
                console.log(tipoDocumento);
                if (!fromUploadFinish) {
                    self.userDaCensire.documento = Documento.build({ idImgDocumentoCfFront: self.userDaCensire.documento.idImgDocumentoCfFront, imgDocumentoCfFront: self.userDaCensire.documento.idImgDocumentoCfFront })
                }
                self.regExpDocumento = tipoDocumento;
                self.listaNomeRilascio = getEntiRilascio(tipoDocumento);

                // if (tipoDocumento == 'PAS' || tipoDocumento == 'CAE') {
                //     var testIfPresent = self.listaProvinceRilascio.findIndex(function (element) {
                //         return element == 'EE'
                //     })
                //     if (testIfPresent < 0) {
                //         self.listaProvinceRilascio.push('EE');
                //     }
                // } else {
                //     self.listaProvinceRilascio = self.listaProvinceRilascio.filter(function (element) {
                //         return element != 'EE'

                //     });

                // }

                if (tipoDocumento == 'CAE') {
                    self.userDaCensire.documento.provincia = 'EE';
                    self.disabledProvRilascioEstera = true;
                } else {
                    self.userDaCensire.documento.provincia = null;
                    self.disabledProvRilascioEstera = false;
                }

                if (tipoDocumento == 'UCO') {
                    self.ucoDocumentSelected = true;
                    self.userDaCensire.documento.provincia = 'RM';
                    var roma = self.mapComuni
                        .find(function (comune) {
                            return comune.nome.toLowerCase() == 'roma';
                        });
                    self.userDaCensire.documento.luogoEsteso = roma;
                    self.setLuogo('documento', roma)
                } else {
                    self.ucoDocumentSelected = false;
                }

                self.listaEntiRilascio();
                self.userDaCensire.documento.tipo = tipoDocumento;
                self.enteRilascioSelezionato(self.listaNomeRilascio[0].name);
                self.enteRilascioModel = self.listaNomeRilascio[0];

                self.documentUpload = self.documentUpload.filter(function (element) {
                    return element.type != 'imgDocument'
                });
                self.disabeldUploadBack = false;
                self.disabeldUploadFront = false;
            }


            self.uploadFinish = function (fromChangeDoc) {
                self.creaComuniResidenza(self.userDaCensire.residenza.provincia, true);
                self.creaCap(self.userDaCensire.residenza.luogoEsteso, true);
                self.unlockDocumentFields = true;
                if (fromChangeDoc) {
                    self.setDocNumRegex(self.userDaCensire.documento.tipo);
                } else {
                    self.setDocNumRegex(self.userDaCensire.documento.tipo, true);
                }
            }


            var getWizardMap = function (viewIndex) {
                return $rootScope.wizardMap
                    .find(function (element) {
                        return element.index == viewIndex
                    }).viewName
            }



            self.upgradeListaComuni = function (value) {
                if (self.userDaCensire.documento.provincia) {
                    self.creaComuniRilascio(self.userDaCensire.documento.provincia);
                }
                self.userDaCensire.documento.luogoEsteso = {
                    nome: value
                }
            }

            var checkFilesUpload = function () {
                var test = false
                if (self.userDaCensire && self.userDaCensire.numDocumenti == 1) {

                    test =
                        self.userDaCensire.documento.uploadedDoc && self.userDaCensire.documento.uploadedDoc.length > 0;

                } else if (self.userDaCensire && self.userDaCensire.numDocumenti == 2) {

                    test =
                        !!self.userDaCensire.documento.imgDocumentoFront &&
                        !!self.userDaCensire.documento.imgDocumentoCfFrontuploadedDoc

                } else if (self.userDaCensire.numDocumenti == 4) {

                    test = !!self.userDaCensire.documento.imgDocumentoCfBack &&
                        !!self.userDaCensire.documento.imgDocumentoCfFront &&
                        !!self.userDaCensire.documento.imgDocumentoBack &&
                        !!self.userDaCensire.documento.imgDocumentoFront &&
                        !!self.userDaCensire.documento.idImgDocumentoBackOther &&
                        !!self.userDaCensire.documento.idImgDocumentoFrontOther &&
                        !!self.userDaCensire.documento.idImgSubjectPhoto;

                }

                return test;

            }

            self.setDate = function (tipo, value) {
                if (tipo === 'dataRilascio') {
                    self.userDaCensire.documento.dataRilascio = value;
                } else {
                    self.userDaCensire.documento.dataScadenza = value;
                }
            }

            self.setLuogo = function (tipo, value, statoOComune) {

                if (tipo == 'documento' && !statoOComune) {
                    self.userDaCensire.documento.luogo = value.nome;
                    self.userDaCensire.documento.stato = null;
                    self.userDaCensire.documento.statoEsteso = null;
                }

                if (statoOComune == 'statoRilascio') {
                    self.userDaCensire.documento.stato = value;
                    self.userDaCensire.documento.statoEsteso = self.listaNomiStatiNascita.find(function (element) {
                        return element.name == value;
                    })


                }

            }

            self.setStatoEsteso = function () {
                self.userDaCensire.residenza.statoEsteso = self.userDaCensire.residenza.stato;
                self.userDaCensire.residenza.idNsil = null;
            }

            self.setResidenza = function (item, value) {
                self.userDaCensire.residenza[item] = value;
                self.userDaCensire.residenza.idNsil = null;
            }


            var getEntiRilascio = function (tipo) {
                if (!tipo) {
                    return;
                }
                var luogoRilascio = [{
                    name: null
                }];
                luogoRilascio[0].name = self.elencoListaEntiRilascio && self.elencoListaEntiRilascio.find(x => {
                    return x.value == tipo
                }).name
                return luogoRilascio;
            }

            var buildLabelsIdMap = function () {
                var labelsIdMap = {};
                var labelEls = document.querySelectorAll("label");
                labelEls.forEach(function (label) {
                    var inputId = label.getAttribute("for");
                    var labelText = label.textContent.trim();
                    if (labelText.indexOf("*") > -1) {
                        labelText = labelText.replace("*", "");
                    }
                    if (inputId) {
                        labelsIdMap[inputId] = labelText;
                    }
                });
                return labelsIdMap;
            };

            var showMissingData = function () {

                $scope.labelsIdMap = buildLabelsIdMap();
                self.listOfInvalid = Object.keys($scope.pfForm)
                    .filter((key) => {
                        return (
                            key.indexOf("$") < 0 &&
                            ($scope.pfForm[key].$invalid ||
                                (key == "comuneRilascio" &&
                                    $scope.pfForm[key].$modelValue &&
                                    !$scope.pfForm[key].$modelValue.nome))
                        );
                    })
                    .flatMap((key) => {
                        if (key == 'typeStreet' && !self.listOfInvalid.includes('INDIRIZZO DI RESIDENZA ')) {
                            return "INDIRIZZO RESIDENZA ";
                        } else if (key != 'typeStreet') {

                            return $scope.labelsIdMap[key] || key;
                        } else { return [] }
                    });

                if (self.userDaCensire.titolare && self.userDaCensire.firmatario && self.userDaCensire.garante && !self.userDaCensire.titolare.selected && !self.userDaCensire.firmatario.selected && !self.userDaCensire.garante.selected) {
                    self.listOfInvalid.push('Selezionare una tra le opzioni Titolare, Firmatario o Garante');

                } else {
                    var index = self.listOfInvalid.indexOf('Selezionare una tra le opzioni Titolare, Firmatario o Garante');
                    if (index > -1) {
                        self.listOfInvalid.splice(index, 1);
                    }
                }


                console.log("data missing is: ", self.listOfInvalid);

            }


        }

    });